
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 200","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M169.258 129.468L138.719 47.68M86.76 157.418l-16.84-56.874","fill":"none","stroke":"#e0e0e0"}}),_c('path',{attrs:{"d":"M46.31 71.88L19.617 88.933l27.946 91.695 39.193-23.214 50.003 1.965 32.5-29.91 49.999-3.482-37.769-77.234-42.765-1.07-30.538 25.089-11.516-1.52","fill":"none","stroke":"#3a3a3a","stroke-width":"6.047"}}),_c('path',{attrs:{"d":"M108.185 72.772l28.573 86.607","fill":"none","stroke":"#3a3a3a","stroke-width":"4"}}),_c('path',{attrs:{"d":"M72.075 14.81A29.646 29.646 0 0042.43 44.456c0 1.897.125 3.764.518 5.556 2.12 9.638 12.015 20.152 27.477 46.616 1.466 2.124 1.625 2.423 3.02.05 15.794-26.03 25.53-38.703 27.911-47.596.393-1.474.36-3.054.36-4.626A29.643 29.643 0 0072.071 14.81zm.091 10.318a16.392 16.392 0 0116.396 16.395A16.392 16.392 0 0172.166 57.92a16.392 16.392 0 01-16.392-16.396 16.392 16.392 0 0116.392-16.392z","fill":"#3a3a3a","paint-order":"stroke fill markers"}}),_c('path',{attrs:{"d":"M179.55 95.653c-8.157-12.378-39.118-19.37-61.077 7.775-21.967 27.144-8.754 19.17-26.207 33.902-19.106 16.123-37.788-15.277-37.788-15.277","fill":"none","stroke":"#3a3a3a","stroke-width":"4.157","stroke-dasharray":"8.31491,8.31491"}}),_c('circle',{attrs:{"cx":"48.053","cy":"115.768","r":"6.992","fill":"none","stroke":"#3a3a3a","stroke-width":"4.157","stroke-linecap":"square","paint-order":"stroke fill markers"}}),_c('circle',{attrs:{"r":"6.992","cy":"108.386","cx":"185.43","fill":"#3a3a3a","stroke":"#3a3a3a","stroke-width":"4.157","stroke-linecap":"square","paint-order":"stroke fill markers"}})])
          )
        }
      }
    